import { render, staticRenderFns } from "./LinkInvoice.vue?vue&type=template&id=612035c8&"
import script from "./LinkInvoice.vue?vue&type=script&lang=js&"
export * from "./LinkInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports